import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    id: string,
    title: string,
}

interface Variables {
    input: {
        description: string,
        rejection_message: string,
        title: string,
        waitTime: number,
    }
}

export const CREATE_APPROVAL_STAGE: TypedDocumentNode<Result, Variables> = gql`
    mutation CreateApprovalStage($input: ApprovalInput){
        createApprovalStage(input: $input) {
            id
            title
        }
    }       
`
